<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
  modelValue: {
    type: Boolean,
    default: null,
  },
  defaultOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const internalOpen = ref(props.defaultOpen);

const isOpen = computed({
  get() {
    return props.modelValue !== null ? props.modelValue : internalOpen.value;
  },
  set(v) {
    if (props.modelValue !== null) emit('update:modelValue', v);
    else internalOpen.value = v;
  },
});

function toggle() {
  isOpen.value = !isOpen.value;
}
</script>

<template>
  <div class="border border-gray-300 dark:border-gray-700 rounded-lg overflow-hidden bg-white dark:bg-gray-800">

    <!-- Header -->
    <div
      class="flex items-center justify-between gap-2 px-4 py-3 bg-gray-50 dark:bg-gray-700 cursor-pointer select-none hover:bg-gray-100 dark:hover:bg-gray-600"
      @click="toggle">
      <div class="flex items-center gap-3 min-w-0">
        <i class="fa fa-chevron-down text-gray-500 transition-transform"
          :class="{ 'rotate-[-90deg]': !isOpen }"></i>
        <i v-if="icon" :class="icon" class="text-gray-500 dark:text-gray-300"></i>
        <slot name="title">
          <span class="font-medium text-gray-800 dark:text-white truncate">{{ title }}</span>
        </slot>
      </div>
      <div class="flex items-center gap-1" @click.stop>
        <slot name="actions" />
      </div>
    </div>

    <!-- Body -->
    <div v-if="isOpen" class="p-4">
      <slot />
    </div>

  </div>
</template>
